import React from 'react';
import { string, shape, arrayOf, object, bool } from 'prop-types';
import { useTranslation } from 'react-i18next';

import useStyles from 'hooks/useStyles';

import CollapseContent from 'components/CollapseContent';

import styles from './Overview.scss';

function Overview({
  elementRef,
  title,
  tabLabel,
  highlightList,
  isLessonPage,
  description,
}) {
  useStyles(styles);
  const { t } = useTranslation(['course']);

  const showHighlightSection = highlightList.length > 0;
  const renderHighlightItem = item => (
    <li className={styles.item} key={item.iconUrl}>
      <div className={styles.img}>
        <img alt="" src={item.iconUrl} />
      </div>
      <div className={styles.title}>{item.title}</div>
    </li>
  );

  return (
    <div ref={elementRef}>
      {!isLessonPage && (
        <section>
          <h1 className={styles.courseTitle}>{title}</h1>
          <CollapseContent
            maxLines={3}
            className={styles.description}
            expandText={t('videoplayer.more')}
          >
            {description}
          </CollapseContent>
        </section>
      )}
      {showHighlightSection && (
        <section>
          <h2>{tabLabel}</h2>
          <ul className={styles.highlightList}>
            {highlightList.map(renderHighlightItem)}
          </ul>
        </section>
      )}
    </div>
  );
}

Overview.propTypes = {
  elementRef: object.isRequired,
  title: string.isRequired,
  description: string.isRequired,
  tabLabel: string.isRequired,
  highlightList: arrayOf(
    shape({
      title: string.isRequired,
      iconUrl: string.isRequired,
      description: string,
    }).isRequired,
  ).isRequired,
  isLessonPage: bool.isRequired,
};

export default Overview;
